import {
  AddressContainer,
  CannotConfirmContainer,
  CardDetailsContainer,
  ConnectingContainer,
  ErrorContainer,
  ManualAddressContainer,
  MeterCodeContainer,
  MoveDateContainer,
  MpanContainer,
  NotCompatibleContainer,
  SuccessContainer,
  SystemUnavailableContainer,
  TermsContainer,
  VerifyContainer,
} from './Onboarding';
import { ConsentContext, ConsentFlows } from '../context/ConsentContext';
import { Navigate, Route, Routes } from 'react-router';
import { useContext, useEffect } from 'react';

import { Alert } from 'react-bootstrap';
import LoginCard from '../ui/LoginCard';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import ReactMarkdown from 'react-markdown';
import { contentfulPropTypes } from '../propTypes';
import { getCurrentUserInfo } from '../utils/auth';
import { setStoreByKey } from '../api/User';
import styled from 'styled-components';
import { useContentfulTag } from '../hooks';
import withContentfulTag from '../utils/withContentfulTag';

const StyledReactMarkdown = styled(ReactMarkdown)`
  p {
    margin-bottom: 0;
  }
`;

const OnboardingContainer = ({ contentful }) => {
  const {
    setHasRegisterMpanTrustedConsent,
    setHasOnboarded,
    setUser,
    consentFlow,
    setConsentFlow,
    onboardingDisabled,
    setOnboardingDisabled,
  } = useContext(ConsentContext);

  const disableOnboarding = useContentfulTag(
    'config_disable_onboarding',
    'keyValuePair',
  );

  const onboardingDisabledContent = useContentfulTag(
    'web_app_onboarding_disabled',
  );

  useEffect(() => {
    if (!disableOnboarding?.loading && disableOnboarding?.fetched) {
      setOnboardingDisabled(disableOnboarding?.contentful?.value === 'true');
    }
  }, [disableOnboarding, setOnboardingDisabled]);

  useEffect(() => {
    // check for attribution data in localStorage and store it permanently
    const storageKey = 'loop-attribution-tags';
    const attributionTags = JSON.parse(localStorage.getItem(storageKey));
    if (!!attributionTags) {
      setStoreByKey(storageKey, attributionTags).then(() => {
        localStorage.removeItem(storageKey);
      });
    }
    // re-initialise onboarding control vars
    setHasRegisterMpanTrustedConsent(false);
    setHasOnboarded(false);
    setConsentFlow(ConsentFlows.ONBOARDING);
    getCurrentUserInfo().then(res => {
      if (res) {
        setUser(res);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const addressPath = contentful.link || `/${consentFlow}/manual-address`;
  return (
    <OnboardingLayout>
      <LoginCard>
        {contentful?.body && (
          <Alert variant={'danger'}>
            <StyledReactMarkdown>{contentful?.body}</StyledReactMarkdown>
          </Alert>
        )}
        {onboardingDisabled && (
          <>
            {onboardingDisabledContent?.contentful && (
              <>
                <h1 className="mb-3">
                  {onboardingDisabledContent?.contentful?.title}
                </h1>
                <StyledReactMarkdown>
                  {onboardingDisabledContent?.contentful?.body}
                </StyledReactMarkdown>
              </>
            )}
          </>
        )}
        {!onboardingDisabled && (
          <Routes>
            <Route index element={<Navigate to={addressPath} replace />} />

            <Route path="address" element={<AddressContainer />} />
            <Route path="manual-address" element={<ManualAddressContainer />} />
            <Route path="move-date" element={<MoveDateContainer />} />
            <Route path="mpan" element={<MpanContainer />} />
            <Route path="not-compatible" element={<NotCompatibleContainer />} />
            <Route path="terms" element={<TermsContainer />} />
            <Route path="verify-address" element={<VerifyContainer />} />
            <Route path="card-details" element={<CardDetailsContainer />} />
            <Route path="connecting" element={<ConnectingContainer />} />
            <Route path="cannot-confirm" element={<CannotConfirmContainer />} />
            <Route path="meter-code" element={<MeterCodeContainer />} />
            <Route path="success" element={<SuccessContainer />} />
            <Route path="error" element={<ErrorContainer />} />
            <Route
              path="system-unavailable"
              element={<SystemUnavailableContainer />}
            />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
        )}
      </LoginCard>
    </OnboardingLayout>
  );
};

OnboardingContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  OnboardingContainer,
  'web_app_onboarding_flow',
);
